import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Input from '../../ui/Input';
import Button from '../../ui/Button';
import { loginSide, logoIcon } from '../../ui/media';

function LoginTwoFactor() {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300); // 5 minutes in seconds
    const navigate = useNavigate();
    const location = useLocation();
    // const { verifyTwoFactorCode, resendTwoFactorCode } = useAuth();

    // Get email from location state
    const email = location.state?.email || '';

    useEffect(() => {
        // Countdown timer
        if (timeLeft > 0) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);
        // try {
        //     const result = await verifyTwoFactorCode(email, code);
        //     if (result.success) {
                setTimeout(() => {
                    navigate('/dashboard');
                }, 4000)
        //     } else {
        //         setError(result.error || 'Invalid verification code');
        //     }
        // } catch (err) {
        //     setError('An unexpected error occurred');
        // } finally {
        //     setIsLoading(false);
        // }
    };

    const handleResendCode = async () => {
        setError('');
        // try {
        //     const result = await resendTwoFactorCode(email);
        //     if (result.success) {
        //         setTimeLeft(300); // Reset timer to 5 minutes
        //     } else {
        //         setError(result.error || 'Failed to resend code');
        //     }
        // } catch (err) {
        //     setError('An unexpected error occurred');
        // }
    };

    return (
        <div className="flex h-screen w-full bg-black text-white">
            {/* Left side with image and testimonial */}
            <div className="relative w-1/2 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/70 z-10"></div>
                {/* Background image */}
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{
                        backgroundImage: `url(${loginSide})`,
                        filter: 'brightness(0.7) sepia(0.2)'
                    }}>
                </div>
                {/* Decorative lights */}
                <div className="absolute inset-0 z-0">
                    {[...Array(6)].map((_, i) => (
                        <div
                            key={i}
                            className="absolute w-6 h-16 bg-amber-300/80 rounded-full blur-sm"
                            style={{
                                top: `${20 + (i * 15)}%`,
                                left: `${15 + ((i % 3) * 30)}%`,
                                boxShadow: '0 0 15px 5px rgba(251, 191, 36, 0.4)'
                            }}
                        ></div>
                    ))}
                </div>
                {/* Logo */}
                <div className="absolute top-6 left-6 z-20 flex items-center">
                    <span className="text-white font-semibold flex items-center">
                        <img
                            src={logoIcon}
                            className="w-6 h-6 mr-2" />
                        Newboo Inc
                    </span>
                </div>
                {/* Testimonial */}
                <div className="absolute bottom-10 left-6 right-6 z-20">
                    <p className="text-xl font-medium leading-relaxed mb-4">
                        "This library has saved me countless hours of work and helped me deliver stunning designs to my clients faster than ever before."
                    </p>
                    <p className="text-sm">Sofia Davis</p>
                </div>
            </div>
            {/* Right side with login form */}
            <div className="w-1/2 flex items-center justify-center bg-white">
                <div className="w-4/5 max-w-md p-6">
                    <div className="text-left mb-8">
                        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                            Two-Factor Authentication
                        </h2>
                        <p className="mt-2 text-center text-sm text-gray-600">
                            We've sent a verification code to your email. Please enter the code to continue.
                        </p>
                    </div>
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        {error && (
                            <div className="bg-red-50 border-l-4 border-red-500 p-4">
                                <p className="text-sm text-red-700">{error}</p>
                            </div>
                        )}
                        <div>
                            <Input
                                id="code"
                                name="code"
                                type="text"
                                label="Verification Code"
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                                placeholder="Enter 6-digit code"
                                required
                                autoComplete="one-time-code"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                maxLength={6}
                                className='text-black'
                            />
                            <p className="mt-2 text-sm text-gray-500">
                                Code expires in {formatTime(timeLeft)}
                            </p>
                        </div>
                        <div>
                            <Button
                                type="submit"
                                variant="primary"
                                size="lg"
                                className="w-full"
                                disabled={isLoading}>
                                {isLoading ? 'Verifying...' : 'Verify'}
                            </Button>
                        </div>
                        <div className="flex items-center justify-center">
                            <button
                                type="button"
                                onClick={handleResendCode}
                                disabled={timeLeft > 270} // Allow resend after 30 seconds
                                className={`font-medium ${timeLeft > 270
                                    ? 'text-gray-400 cursor-not-allowed'
                                    : 'text-indigo-600 hover:text-indigo-500'
                                    }`}>
                                Didn't receive the code? Resend
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
export default LoginTwoFactor;